import { Services } from "../../services/Services.js";
import { DataService } from "./DataService.js";

export class DataEndpoint {

    constructor(servicePath, authManager) {

        this.dataService = new DataService(servicePath, authManager);

    };

    // --------------------------------------------------------------------------------------------

    createServiceUrl(servicePath) {

        const config = Services.get('config');

        let baseUrl = this.normalizePath(config.baseUrl, true),
            basePath = this.normalizePath(config.apiBaseUrl);

        servicePath = this.normalizePath(servicePath);

        return baseUrl + basePath + servicePath;

    };

    normalizePath(path, skipOpeningCheck) {

        if (path === undefined)
            return '';
        if (path === null)
            return '';
        if (path === '')
            return path;
        if (!skipOpeningCheck && path.at(0) != '/')
            path = '/' + path;
        if (path.at(-1) == '/')
            path = path.slice(0, path.length - 1);

        return path;

    };

    // --------------------------------------------------------------------------------------------

    async callService(method, path, data, params) {

        path = this.normalizePath(path);

        const response = await this.dataService.call(method, path, data, params);

        return response;

    };

    async get(path, data, params) {

        return this.callService('GET', path, data, params);

    };

    async put(path, data, params) {

        return this.callService('PUT', path, data, params);

    };

    async post(path, data, params) {

        return this.callService('POST', path, data, params);

    };

    async delete(path, data, params) {

        return this.callService('DELETE', path, data, params);

    };

    // --------------------------------------------------------------------------------------------

    async queryData(query) {

        return this.get('', query);

    };

    async createData(data) {

        return this.post('', data);

    };

    async readData(id) {

        return this.get(`/${id}`);

    };

    async updateData(id, data) {

        return this.put(`/${id}`, data);

    };

    async deleteData(id) {

        return this.delete(`/${id}`);

    };

}
